import React from 'react';

const EyeIcon = ({ width = 0, color = '#fff' }) => {
  const widthValue = 24;
  const heightValue = 16;
  const convertHeight = !!width ? (heightValue * width) / widthValue : null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || widthValue}
      height={convertHeight || heightValue}
      viewBox="0 0 24 16"
      fill="none"
    >
      <path
        d="M23.855 7.39167C21.5954 2.98292 17.1221 0 12 0C6.87791 0 2.40332 2.985 0.144977 7.39208C0.0496614 7.58063 0 7.78894 0 8.00021C0 8.21148 0.0496614 8.41979 0.144977 8.60833C2.40457 13.0171 6.87791 16 12 16C17.1221 16 21.5967 13.015 23.855 8.60792C23.9503 8.41937 24 8.21106 24 7.99979C24 7.78852 23.9503 7.58021 23.855 7.39167ZM12 14C10.8133 14 9.65327 13.6481 8.66657 12.9888C7.67988 12.3295 6.91084 11.3925 6.45671 10.2961C6.00259 9.19974 5.88377 7.99334 6.11528 6.82946C6.34679 5.66557 6.91823 4.59647 7.75735 3.75736C8.59647 2.91824 9.66557 2.3468 10.8295 2.11529C11.9933 1.88378 13.1997 2.0026 14.2961 2.45672C15.3925 2.91085 16.3295 3.67988 16.9888 4.66658C17.6481 5.65327 18 6.81331 18 8C18.0004 8.78804 17.8455 9.56843 17.5441 10.2966C17.2427 11.0247 16.8007 11.6863 16.2435 12.2435C15.6863 12.8007 15.0247 13.2427 14.2966 13.5441C13.5684 13.8455 12.788 14.0004 12 14ZM12 4C11.643 4.00499 11.2882 4.05811 10.9454 4.15792C11.228 4.54195 11.3636 5.01454 11.3276 5.48998C11.2917 5.96542 11.0865 6.41223 10.7494 6.74938C10.4122 7.08652 9.96541 7.29168 9.48997 7.32765C9.01453 7.36362 8.54194 7.22801 8.15791 6.94542C7.93923 7.75108 7.9787 8.60503 8.27078 9.38708C8.56285 10.1691 9.09282 10.8399 9.78608 11.305C10.4793 11.7701 11.301 12.006 12.1354 11.9797C12.9698 11.9533 13.7749 11.666 14.4375 11.158C15.1 10.6501 15.5866 9.94726 15.8287 9.14833C16.0708 8.3494 16.0563 7.49466 15.7872 6.70441C15.5181 5.91415 15.008 5.22818 14.3286 4.74305C13.6492 4.25791 12.8348 3.99803 12 4Z"
        fill={color}
      />
    </svg>
  );
};

export default React.memo(EyeIcon);
